import React, { useState } from 'react';

import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const AuditFilters = ({ onFiltersChange, resultsCount }) => {
  const [filters, setFilters] = useState({
    dateRange: { start: '', end: '' },
    user: '',
    brand: '',
    model: '',
    version: '',
    ipAddress: '',
    geoLocation: '',
    status: '',
    vinSearch: ''
  });

  const [isExpanded, setIsExpanded] = useState(false);

  const userOptions = [
    { value: '', label: 'Todos los usuarios' },
    { value: 'admin@vinpro.mx', label: 'Admin Principal' },
    { value: 'operador1@vinpro.mx', label: 'Carlos Mendoza' },
    { value: 'operador2@vinpro.mx', label: 'Ana García' },
    { value: 'auditor@vinpro.mx', label: 'María López' }
  ];

  const brandOptions = [
    { value: '', label: 'Todas las marcas' },
    { value: 'nissan', label: 'Nissan' },
    { value: 'toyota', label: 'Toyota' },
    { value: 'volkswagen', label: 'Volkswagen' },
    { value: 'chevrolet', label: 'Chevrolet' },
    { value: 'ford', label: 'Ford' },
    { value: 'honda', label: 'Honda' }
  ];

  const statusOptions = [
    { value: '', label: 'Todos los estados' },
    { value: 'success', label: 'Exitoso' },
    { value: 'error', label: 'Error' },
    { value: 'timeout', label: 'Tiempo agotado' },
    { value: 'invalid', label: 'VIN inválido' }
  ];

  const geoLocationOptions = [
    { value: '', label: 'Todas las ubicaciones' },
    { value: 'mexico-city', label: 'Ciudad de México' },
    { value: 'guadalajara', label: 'Guadalajara' },
    { value: 'monterrey', label: 'Monterrey' },
    { value: 'puebla', label: 'Puebla' },
    { value: 'tijuana', label: 'Tijuana' }
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...filters, [key]: value };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const handleDateRangeChange = (type, value) => {
    const newDateRange = { ...filters?.dateRange, [type]: value };
    const newFilters = { ...filters, dateRange: newDateRange };
    setFilters(newFilters);
    onFiltersChange(newFilters);
  };

  const clearAllFilters = () => {
    const clearedFilters = {
      dateRange: { start: '', end: '' },
      user: '',
      brand: '',
      model: '',
      version: '',
      ipAddress: '',
      geoLocation: '',
      status: '',
      vinSearch: ''
    };
    setFilters(clearedFilters);
    onFiltersChange(clearedFilters);
  };

  const hasActiveFilters = Object.values(filters)?.some(value => {
    if (typeof value === 'object' && value !== null) {
      return Object.values(value)?.some(v => v !== '');
    }
    return value !== '';
  });

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-4">
          <h3 className="text-lg font-semibold text-foreground">Filtros de Auditoría</h3>
          {resultsCount !== undefined && (
            <span className="text-sm text-muted-foreground bg-muted px-3 py-1 rounded-full">
              {resultsCount?.toLocaleString('es-MX')} resultados
            </span>
          )}
        </div>
        <div className="flex items-center space-x-2">
          {hasActiveFilters && (
            <Button
              variant="ghost"
              size="sm"
              onClick={clearAllFilters}
              iconName="X"
              iconPosition="left"
              iconSize={16}
            >
              Limpiar filtros
            </Button>
          )}
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? "ChevronUp" : "ChevronDown"}
            iconPosition="right"
            iconSize={16}
          >
            {isExpanded ? 'Menos filtros' : 'Más filtros'}
          </Button>
        </div>
      </div>
      {/* Quick Search */}
      <div className="mb-4">
        <Input
          type="search"
          placeholder="Buscar por VIN o usuario..."
          value={filters?.vinSearch}
          onChange={(e) => handleFilterChange('vinSearch', e?.target?.value)}
          className="max-w-md"
        />
      </div>
      {/* Basic Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <div>
          <Input
            type="date"
            label="Fecha inicio"
            value={filters?.dateRange?.start}
            onChange={(e) => handleDateRangeChange('start', e?.target?.value)}
          />
        </div>
        <div>
          <Input
            type="date"
            label="Fecha fin"
            value={filters?.dateRange?.end}
            onChange={(e) => handleDateRangeChange('end', e?.target?.value)}
          />
        </div>
        <div>
          <Select
            label="Usuario"
            options={userOptions}
            value={filters?.user}
            onChange={(value) => handleFilterChange('user', value)}
          />
        </div>
        <div>
          <Select
            label="Estado"
            options={statusOptions}
            value={filters?.status}
            onChange={(value) => handleFilterChange('status', value)}
          />
        </div>
      </div>
      {/* Advanced Filters */}
      {isExpanded && (
        <div className="border-t border-border pt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div>
              <Select
                label="Marca"
                options={brandOptions}
                value={filters?.brand}
                onChange={(value) => handleFilterChange('brand', value)}
                searchable
              />
            </div>
            <div>
              <Input
                type="text"
                label="Modelo"
                placeholder="Ej: Sentra, Corolla..."
                value={filters?.model}
                onChange={(e) => handleFilterChange('model', e?.target?.value)}
              />
            </div>
            <div>
              <Input
                type="text"
                label="Versión"
                placeholder="Ej: Advance, SR..."
                value={filters?.version}
                onChange={(e) => handleFilterChange('version', e?.target?.value)}
              />
            </div>
            <div>
              <Input
                type="text"
                label="Dirección IP"
                placeholder="Ej: 192.168.1.1"
                value={filters?.ipAddress}
                onChange={(e) => handleFilterChange('ipAddress', e?.target?.value)}
              />
            </div>
            <div>
              <Select
                label="Ubicación geográfica"
                options={geoLocationOptions}
                value={filters?.geoLocation}
                onChange={(value) => handleFilterChange('geoLocation', value)}
                searchable
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditFilters;